
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLocationT as ObiLocationTElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-location-t.js';
 
 
 

 
 export const ObiLocationT = createComponent({
   react: React,
   tagName: 'obi-location-t',
   elementClass: ObiLocationTElement,
   events: {
     
   }
  });
 
 